<div class="gsearch-backdrop" (click)="close.emit()">
  <div class="gsearch-panel" (click)="$event.stopPropagation()">
    <div class="gsearch-input-row">
      <i class="fe fe-search gsearch-input-icon" aria-hidden="true"></i>
      <input
        #searchInput
        class="gsearch-input"
        type="text"
        placeholder="Ir para uma página ou procurar uma ocorrência…"
        [value]="query()"
        (input)="onQuery($event)"
        (keydown)="onKeydown($event)"
        autocomplete="off"
        spellcheck="false"
        aria-label="Busca global"
      />
      <span class="gsearch-hint-key">esc</span>
    </div>

    <div class="gsearch-results">
      @for (item of items(); track item.label; let i = $index) {
        <button
          type="button"
          class="gsearch-item"
          [class.gsearch-item--active]="highlighted() === i"
          (click)="select(item)"
          (mouseenter)="setHighlight(i)"
        >
          <span class="gsearch-item-icon"><i class="fe {{ item.icon }}"></i></span>
          <span class="gsearch-item-body">
            <span class="gsearch-item-title">{{ item.label }}</span>
            @if (item.hint) { <span class="gsearch-item-sub">{{ item.hint }}</span> }
          </span>
          <i class="fe fe-corner-down-left gsearch-item-enter" aria-hidden="true"></i>
        </button>
      } @empty {
        @if (searching()) {
          <div class="gsearch-empty">A procurar…</div>
        } @else {
          <div class="gsearch-empty">Nenhum resultado para “{{ query() }}”.</div>
        }
      }
    </div>
  </div>
</div>
